import {NgModule} from '@angular/core';
import {AdminRouterModule} from './admin.router.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {CoreModule} from '../CoreModule/core.module';
import {HorariosTiendaComponent, TiendaEditComponent, TiendasCrudComponent} from './components/tiendas.crud.component';
import {
  UsuarioEditComponent,
  UsuarioNewComponent,
  UsuariosCrudComponent
} from './components/usuarios.crud.component';
import {RolCrudComponent, RolEditComponent, RolNewComponent} from './components/roles.crud.component';
import {FriedmanModule} from '../FriedmanModule/friedman.module';
import {BusquedaEmpleadoComponent} from './components/busqueda.empleado.component';
import {AdminSecurityServices} from './services/admin.security.services';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CargosCrudComponent, CargosEditComponent, CargosNewComponent} from './components/cargos.crud.component';
import {EditGrupoCargoComponent, GrupoCargosCrudComponent, NewGrupoCargoComponent} from './components/grupo.cargos.crud.component';
import {LogComponent} from './components/log.component';
import {TypeaheadModule} from 'ngx-bootstrap';

@NgModule({
  declarations:[
    TiendasCrudComponent,
    TiendaEditComponent,
    HorariosTiendaComponent,
    UsuariosCrudComponent,
    UsuarioEditComponent,
    UsuarioNewComponent,
    RolCrudComponent,
    RolEditComponent,
    RolNewComponent,
    BusquedaEmpleadoComponent,
    CargosCrudComponent,
    CargosEditComponent,
    CargosNewComponent,
    GrupoCargosCrudComponent,
    NewGrupoCargoComponent,
    EditGrupoCargoComponent,
    LogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    CoreModule,
    AdminRouterModule,
    FriedmanModule,
    NgxDatatableModule,
    TypeaheadModule
  ],
  providers:[AdminSecurityServices],
  exports:[]
})
export class AdminModule {

}
